(function () {
	const parentForm = $('#filter-form');
	const filters = parentForm.find('.single-filter');
	const pageAwareFilter = parentForm.find('[data-filter-name="targetGroup"]');
	const filterSpanSelect = parentForm.find('[data-filter-type="span-select"]');
	const filterSelect = parentForm.find('[data-filter-type="select"] select');
	const filterSpans = filterSpanSelect.find('.filter-value-span');
	const filterSpanSelectTagSelectContainer = $('<div class="select-container"></div>'); // Create a container for the select
	const filterSpanSelectTagSelect = $('<select class="form-select"></select>');  // Create the select element

// Function to transform spans to a select or vice versa
	function transformToSelect() {
		if ($(window).width() < 992) { // If the screen size is smaller than 992px
			// Check if the select exists and is empty
			if (filterSpanSelectTagSelect.children().length === 0) {
				// Populate the select if it's empty
				filterSpans.each(function () {
					const value = $(this).data('value');
					const ref = $(this).data('ref');
					const text = $(this).text();
					filterSpanSelectTagSelect.append(`<option value="${value}" data-value="${value}" data-ref="${ref}">${text}</option>`);
				});
			}

			filterSpanSelectTagSelectContainer.append(filterSpanSelectTagSelect); // Add select to container
			filterSpans.hide(); // Hide the original spans
			filterSpans.last().after(filterSpanSelectTagSelectContainer); // Insert after the last span

			filterSpans.on('click', function () {
				filterSpans.removeClass('active');
				$(this).addClass('active');
			});

			// Detach click event from spans (prevents double triggering)
			filterSpans.off('click');
		} else {
			// Restore spans if the screen size is larger or equal to 992px
			// Restore spans
			filterSpanSelectTagSelectContainer.remove(); // Remove the select box
			filterSpans.show();  // Show spans

			// Re-attach click event to spans
			filterSpans.on('click', function () {
				// Existing click functionality
				filterSpans.removeClass('active');
				$(this).addClass('active');
			});
		}
		updateFilterView();
	}

	function updateFilterView() {
		filterSpans.removeClass('active');
		filterSpanSelectTagSelectContainer.find('option:selected').removeAttr('selected');
		filterSelect.find('option:selected').removeAttr('selected');
		savedFilter = fetchSavedData();
		if (typeof savedFilter !== 'undefined') {
			$.each(savedFilter, function () {
				filterData = this;
				filter = parentForm.find('[data-filter-name="' + filterData.name + '"]');
				switch (filterData.type) {
					case 'span-select':
						filter.find('span[data-value="' + filterData.value + '"]').addClass('active');
						filter.find('option[data-value="' + filterData.value + '"]').attr('selected', 'selected');
						break;
					case 'select':
						filter.find('select option[value="' + filterData.value + '"]').attr('selected', 'selected');
						break;
				}
			});
		}
		if (typeof currentPageCategories !== 'undefined' && count(currentPageCategories)) {
			pageAwareFilter.find('span.active').removeClass('active');
			pageAwareFilter.find('option:selected').removeClass('active');
			$.each($(currentPageCategories), function () {
				pageAwareFilter.find('span[data-value="' + this + '"]').addClass('active');
				pageAwareFilter.find('option[data-value="' + this + '"]').attr('selected', 'selected');
			});
		}
	}

	function updateFilterData() {
		var filterData = [];
		filters.each(function (index) {
			filter = $(this);

			switch (filter.data('filter-type')) {
				case 'span-select':
					filterValue = '';
					filterRef = '';
					filterType = 'span-select';
					if (filter.find('span.active:visible').length) {
						filterValue = filter.find('span.active:visible').data('value');
						filterRef = filter.find('span.active:visible').data('ref');
					}
					if (filter.find('.select-container select').length) {
						filterValue = filter.find('.select-container select option:selected').data('value');
						filterRef = filter.find('.select-container select option:selected').data('ref');
					}
					filterData.push(
						{
							name: filter.data('filter-name'),
							value: filterValue,
							ref: filterRef,
							type: filterType
						}
					);
					break;
				case 'select':
					filterValue = '';
					filterType = 'select';
					if (filter.find('select').length) {
						filterValue = filter.find('option:selected').val();
					}
					filterData.push(
						{
							name: filter.data('filter-name'),
							value: filterValue,
							type: filterType
						}
					);
					break;
			}
		});
		localStorage.setItem('globalFilters', JSON.stringify(filterData));
	}

	function fetchSavedData() {
		savedFilterStoredValue = localStorage.getItem('globalFilters');
		savedFilter = []
		if (savedFilterStoredValue !== null) {
			savedFilter = JSON.parse(savedFilterStoredValue);
		}
		return savedFilter;
	}

	function redirectToPageFilterValue() {
		pageAwareFilterRef = null;
		if (pageAwareFilter.find('span.active').length) {
			pageAwareFilterRef = pageAwareFilter.find('span.active').data('ref')
		}
		if (pageAwareFilter.find('option:selected').length) {
			pageAwareFilterRef = pageAwareFilter.find('option:selected').data('ref')
		}
		if (pageAwareFilterRef !== null) {
			document.location.href = pageAwareFilterRef;
		}
	}

	$('.filterSubmit').click(function (e) {
		e.preventDefault();
		updateFilterData();
		redirectToPageFilterValue();
	})
// Call the function on page load and resize
	transformToSelect();
	$(window).resize(transformToSelect);
})();
